import React, { useState } from 'react';
import Skills from './Skills';
import ContentCard from './ContentCard';
import About from './About';
import Projects from './Projects';
import Experience from './Experience';
import Education from './Education';
import Resume from './Resume';

export default function Navbar() {

  const[cont, setContent] = useState(<About/>);
  
  const changeContent = (e) => {
    if(e.target.getAttribute('data-value') === 'about'){
      setContent(<About/>)
    }
    else if(e.target.getAttribute('data-value') === 'skills'){
      setContent(<Skills/>);
    }
    else if(e.target.getAttribute('data-value') === 'projects'){
      setContent(<Projects/>);
    }
    else if(e.target.getAttribute('data-value') === 'experience'){
      setContent(<Experience/>);
    }
    else if(e.target.getAttribute('data-value') === 'education'){
      setContent(<Education/>);
    }
    else if(e.target.getAttribute('data-value') === 'resume'){
      setContent(<Resume/>);
    }
  }


  return (
    <>
      <nav className="nav-menu mynav">
          <nav className="container nav-menu-child flex flex-row items-center text-sm">
              <span className="navbar-brand" onClick={changeContent} data-value='about'>  
                <i className="fa-solid fa-code"></i>
                <span className="ml-2 text-md font-bold md:inline overflow-hidden whitespace-nowrap text-ellipsis" onClick={changeContent} data-value='about'>
                  &nbsp;NAYAAB PHANSOPKAR
                </span>
              </span>
              <div className="flex-row flex-1 self-center h-full justify-center md:flex">
                <span className='skill-head-button' onClick={changeContent} data-value='skills'>
                  <i className="fa-brands fa-stack-overflow"></i>
                  <span className='subheadingbtn skillheading' onClick={changeContent} data-value='skills'>&nbsp;Skills</span>
                </span>
                <span className='project-head-button' onClick={changeContent} data-value="projects">
                  <i className="fa-brands fa-squarespace"></i>
                  <span className='subheadingbtn projectheading' onClick={changeContent} data-value="projects">&nbsp;Projects</span>
                </span>
                <span className='experience-head-button' onClick={changeContent} data-value="experience">
                  <i className="fa-regular fa-map"></i>
                  <span className='subheadingbtn experienceheading' onClick={changeContent} data-value='experience'>&nbsp;Experience</span>
                </span>
                <span className='education-head-button' onClick={changeContent} data-value="education">
                  <i className="fa-solid fa-graduation-cap"></i>
                  <span className='subheadingbtn educationheading' onClick={changeContent} data-value='education'>&nbsp;Education</span>
                </span>
                <span className='resume-head-button' value="resume" onClick={changeContent} data-value="resume">
                  <i className="fa-regular fa-file"></i>
                  <span className='subheadingbtn resumeheading' onClick={changeContent} data-value='resume'>&nbsp;Resume</span>
                </span>
              </div>
              {/* <div className="actionarea">
                <i className="fa-solid fa-magnifying-glass"></i>
              </div> */}
          </nav>
      </nav>
      <ContentCard content={cont}/>
    </>
  )
}
